<div [ngClass]="message?.author.id === currentUser?.id ? 'text-right': '' ">

  <!-- User Message -->
  @if (message?.author.id === currentUser.id) {
    <div>
      @if (message?.type == 'image') {
        <div>
          <a target="_blank" href="#" (click)="$event.preventDefault();">
            <img [src]="message?.imageUrl" alt="{{message?.text}}" style="width:10rem">
          </a>
        </div>
      }
      @if (message?.text) {
        <div>
          <span class="badge badge-pill message message-user dda-message dda-message-user">
            <p class="card-text" [innerHTML]="message?.text"></p>
          </span>
          <p class="small text-muted dda-color-contrast-timestamp">{{message?.author.name}}
            {{message?.sentAt.format("HH:mm")}}
          </p>
        </div>
      }
    </div>
  }

  <!-- Bot Message -->
  @if (message?.author.id !== currentUser.id) {
    <div>
      @if (message?.type == 'image') {
        <div>
          <img src="message?.imageUrl">
        </div>
      }
      @if (message?.type == 'system-message') {
        <div>
          <div style="display:inline">
            <span>
              <p [ngStyle]="{'font-style':'italic','color':'gray','margin-left':'40%'}"
              [innerHTML]="message?.text"></p>
            </span>
          </div>
        </div>
      }
      @if (message?.text) {
        <div >
          <!--<div style="display:inline" >
          <img src="assets/esme_avtar.png">
        </div> !-->
        @if (message?.type != 'system-message') {
          <div style="display:inline">
            <span class="badge badge-pill message message-bot mitie-badge-info dda-message dda-message-bot"
              style=" border-radius: 0px 16px 16px 16px;">
              <p [ngStyle]="message?.fulfilledIntent === 'help' ? {'padding-top':'5px'} : ''" class="card-text"
              [innerHTML]="message?.text"></p>
            </span>
          </div>
        }
      </div>
    }
    <!-- show tiles -->
    @for (tile of message?.tiles; track tile) {
      <div class="row" style="padding-top: .5rem;">
        <div class="col-9">
          <div class="card bg-light">
            @if (tile.title) {
              <div class="card-header brand-color">
                {{ tile.title }} <div [ngStyle]="{'float': 'right' }">{{ tile.quoteValue }}</div>
              </div>
            }
            <div class="card-body">
              <h5 class="card-title">{{ tile.subtitle }}</h5>
              <!-- <div class="row" *ngFor="let option of tile.list"> -->
              @for (option of tile.list; track option) {
                <div>
                  <!-- <div class="col-12"> -->
                  @if (isString(option.value)) {
                    <div>
                      <a href="#" class="card-link" (click)="onSelectedOptionClick(option)">{{option.label}}</a>
                    </div>
                  }
                  @if (tile.quoteValue && isString(option.value)) {
                    <div [ngStyle]="{'float': 'right'}">
                      <button class="btn btn-primary" type="button"  (click)="onSelectedOptionClick(option)">
                        Approve quote
                      </button>
                    </div>
                  }
                  @if (isString(option.value) ? false:true) {
                    <div>
                      Supporting Documents:
                      <br />
                      @for (doc of option.value; track doc) {
                        <div>
                          <a [href]="doc.description" class="card-link" target="_blank">{{doc.description}}</a>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <!-- End of show tiles -->
    <!-- show list  -->
    @if (message?.list.list) {
      <div style="padding-top: .5rem;">
        <div class="row">
          <div class="col-10">
            @if (message?.list.list.length > pageSize) {
              <div class="form-group ">
                <input type="text" class="form-control" id="search-text" aria-describedby="search-text" [disabled]="!isActive"
                  [(ngModel)]="searchText" placeholder="Enter text to filter results" [tabindex]="isActive ? 0 : -1" >
                </div>
              }
              <ul class="list-group" style="display:inline-flex">
                @for (list of message?.list.list | appFilter: searchText | slice: (currentPage - 1) * pageSize : ((currentPage - 1) * pageSize) + pageSize; track list) {
                  <a href="#" class="vmj" (click)="isActive && onSelectedListItemClick(list)" [ngClass]="{'disabled': !isActive}"
                    appHighlight [searchedWord]="searchText" [content]="list.label" [tabindex]="isActive ? 0 : -1" >
                    {{list.label}}
                  </a>
                }
              </ul>
              @if (isActive && message?.list.list.length > pageSize) {
                <div>
                  <ngb-pagination [(page)]="currentPage" [pageSize]="pageSize" [maxSize]="10"
                    [collectionSize]="(message?.list.list | appFilter: searchText).length">
                  </ngb-pagination>
                </div>
              }
            </div>
          </div>
          <!-- End of show tiles -->
        </div>
      }
      @if (message?.showTime) {
        <p class="small text-muted dda-color-contrast-timestamp">{{message?.author.name}}
          {{message?.sentAt.format("HH:mm")}}
        </p>
      }
      @if (message?.list.tree) {
        <div style="width:55%;">
          <div class="tree-wrapper" style="width: -webkit-fill-available;">
            <div style="display: inline;">
              <div class="card" style="border:none;border-radius: 0px 0px 10px 10px;">
                <div class="card-body card-text cardTree scrollbarTree" id="style-2"
                  style="  padding:0px!important; overflow-y: auto; ">
                  <app-tree (selectedTreeItem)="onSelectedTreeItemClick($event)" [isActive]="isActive"
                  [treeData]="message?.list.tree | treeFilter : searchText" [searchTxt]="searchText"></app-tree>
                </div>
              </div>
            </div>
            @if (isActive) {
              <div style="display: inline;">
                <label class="labelTreeComponent" style="width: -webkit-fill-available;" autofocus>
                  <input type="email" class="form-control" id="search-text" aria-describedby="search-text"
                    [(ngModel)]="searchText" placeholder="Filter results" [tabindex]="isActive ? 0 : -1"
                    style="background-color:transparent;border:none" [disabled]="!isActive">
                  </label>
                </div>
              }
            </div>
            <!--
            <div class="tree-wrapper d-lg-none" style="width:100%;">
              <div  style="display: inline;">
                <input  type="email" class="form-control labelTreeComponent" id="search-text" aria-describedby="search-text"
                  [(ngModel)]="searchText" placeholder="Enter location" style="background-color:  #f8f9fa;"  autofocus>
                </div>
                <div style="display: inline;">
                  <div class="card">
                    <div class="card-body cardTree" style="overflow-y: auto;">
                      <app-tree (selectedTreeItem)="onSelectedtreeItemClick($event)"  [treeData]="message.list.tree | treeFilter : searchText" [searchTxt]="searchText"></app-tree>
                    </div>
                  </div>
                </div>
              </div> !-->
              <!-- <input type="email" class="form-control" id="search-text" aria-describedby="search-text"
              [(ngModel)]="searchText" placeholder="Enter text to filter results" autofocus>
              <app-tree [treeData]="message.list.tree | treeFilter: searchText" (selectedListItem)="onSelectedtreeItemClick($event)"></app-tree> !-->
            </div>
          }
          <!-- End of Bot Message -->
        </div>
      }

    </div>